export default "__VITE_ASSET__b36aee0e__"